import { render, staticRenderFns } from "./AddCommission.vue?vue&type=template&id=0ded9384&scoped=true"
import script from "./AddCommission.vue?vue&type=script&lang=js"
export * from "./AddCommission.vue?vue&type=script&lang=js"
import style0 from "./AddCommission.vue?vue&type=style&index=0&id=0ded9384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded9384",
  null
  
)

export default component.exports